import { seoOgTwitterCard } from './SeoStore';

export const updateSeoOgTwitterCard = (value) => seoOgTwitterCard.update(oldValue => value);
